export default __webpack_public_path__ + "static/media/vcm50_05.5d561744.jpg";